import { type AxiosResponse } from 'axios'
import type { AxiosOptions } from 'shared/api'
import { baseApi } from 'entities/Auth'
import {
  type ICustomPriceCreateForm,
  type ICustomPriceUpdateForm,
  type IParamsGetCustomPrices,
  type IResponseCreateCustomPrice,
  type IResponseCustomPrice,
  type IResponseCustomPrices,
} from 'entities/Admin/customPrices/api/type'

class Api {
  getCustomPrices(
    params?: IParamsGetCustomPrices,
    options?: AxiosOptions
  ): Promise<AxiosResponse<IResponseCustomPrices>> {
    return baseApi.get('admin/core/custom-price', { params, ...options })
  }

  removeCustomPrices(id: number): Promise<void> {
    return baseApi.delete(`admin/core/custom-price/${id}/`)
  }

  saveCustomPrice(
    data: ICustomPriceCreateForm
  ): Promise<AxiosResponse<IResponseCreateCustomPrice>> {
    return baseApi.post('admin/core/custom-price/', data)
  }

  publishCustomPrice(id: number): Promise<void> {
    return baseApi.post(`admin/core/custom-price/${id}/publish`)
  }

  getCustomPrice(id: number): Promise<AxiosResponse<IResponseCustomPrice>> {
    return baseApi.get(`admin/core/custom-price/${id}`)
  }

  updateCustomPrice(
    id: number,
    data: ICustomPriceUpdateForm | ICustomPriceCreateForm
  ): Promise<AxiosResponse<IResponseCustomPrice>> {
    return baseApi.put(`admin/core/custom-price/${id}`, data)
  }
}

export const AdminCustomPriceApi = new Api()
